/**
 * Add placeholder element for embed blocks (e.g. Youtube) for users who have not given consent for cookies
 */
function cookiebotPlaceholder() {
	// Get the youtube blocks
	const youtubeBlocks = document.querySelectorAll('.wp-block-embed-youtube');

	const init = () => {
		if (youtubeBlocks.length) {
			const config = window.emYtkBlocksConfig;

			// Get the Polylang translation strings from emYtkBlocksConfig
			const cbPlaceholderDesc =
				config?.text?.cbPlaceholderDesc ??
				'Klikkaa painiketta ja hyväksy analytiikkaevästeet katsellaksesi upotettua sisältöä';
			const cbPlaceholderCta =
				config?.text?.cbPlaceholderCta ?? 'Muuta evästeasetuksia';

			youtubeBlocks.forEach((block) => {
				// Define the text and div creation functions
				const createText = (text) => document.createTextNode(text);
				const createElement = (elem) => document.createElement(elem);

				block.querySelectorAll('iframe').forEach((e) => {
					// Check if iframe has "cookieblock-src" dataset and Google Maps, Youtube or Vimeo within the dataset
					const blockSrc = e.dataset.cookieblockSrc;

					// eslint-disable-next-line no-nested-ternary
					const platform = /google\.com\/maps\/embed/.test(blockSrc)
						? 'Google Maps'
						: /player\.vimeo\.com\/video\//.test(blockSrc) // eslint-disable-line no-nested-ternary
						? 'Vimeo'
						: /youtube\.com\/embed\//.test(blockSrc)
						? 'YouTube'
						: undefined;

					// If none of the platform string above match, do nothing
					if (!platform) {
						return;
					}

					// Create the content for the placeholder element
					const link = createElement('a');
					const div = createElement('div');
					const divInner = createElement('div');
					const paragraph = createElement('p');

					div.classList.add('cookieconsent-optout-marketing');

					div.append(divInner);
					divInner.classList.add(
						'cookieconsent-optout-marketing__content'
					);

					// Create the link button for revealing the Cookiebok settings modal
					link.textContent = cbPlaceholderCta;
					link.href = 'javascript:Cookiebot.renew()';
					link.classList.add('button');

					// Construct a new description text with the platform name applied
					const cbDescSplit = cbPlaceholderDesc.split(' ');
					cbDescSplit.splice(-1, 0, platform);
					const cbDescReformed = cbDescSplit.join(' ');

					// Apply text to the paragraph element
					paragraph.append(createText(cbDescReformed));

					// Append the paragraph and link elements
					divInner.append(paragraph);
					divInner.append(link);

					e.parentNode.insertBefore(div, e);
				});
			});
		}
	};

	init();
}

export default cookiebotPlaceholder;
